import { render, staticRenderFns } from "./SizeLimit.vue?vue&type=template&id=5452e0ea&scoped=true&"
var script = {}
import style0 from "./SizeLimit.vue?vue&type=style&index=0&id=5452e0ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5452e0ea",
  null
  
)

export default component.exports